import "./ShareSocialMediaButtons.scss";

import ShareSocialMediaButtons from "./ShareSocialMediaButtons";

export default ShareSocialMediaButtons;
